import React, { useEffect, useState } from 'react';
import HtmlTagRendering from '..';
import {IProps, IState, IHtmlTagDefinition} from '../types';

const SpanElement:React.FC<IProps> = (props) => {
  return (
    <span
        {...props.tagDefinition.properties}
    >
    {
        props.tagDefinition.innerText &&
        <>
        {
            props.tagDefinition.innerText
        }
        </>
    }
    {
        props.tagDefinition.childrens &&
        <>
        {
            props.tagDefinition.childrens.map((children: IHtmlTagDefinition) => {
                return (
                    <HtmlTagRendering tagDefinition={{tagName: children.tagName, properties: children.properties, childrens: children.childrens, innerText: children.innerText}}/>
                );
            })
        }
        </>
    }
    </span>
  );
}

export default SpanElement;